import { render, staticRenderFns } from "./solicitud.vue?vue&type=template&id=71930351&scoped=true&"
import script from "./solicitud.vue?vue&type=script&lang=js&"
export * from "./solicitud.vue?vue&type=script&lang=js&"
import style0 from "./solicitud.vue?vue&type=style&index=0&id=71930351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71930351",
  null
  
)

export default component.exports